import { HttpGraphMicrosoftRequest } from './HttpRequest'

export const GetImageProfile = async () => {
    try {
        const response = await HttpGraphMicrosoftRequest().get(`/v1.0/me/photo/$value`, {
            headers: { 'Content-Type': 'image/*' },
            responseType: 'arraybuffer',
        })
        if (response.status === 200) {
            var binary = '';
			var bytes = new Uint8Array(response.data);
			var len = bytes.byteLength;
			for (var i = 0; i < len; i++) {
				binary += String.fromCharCode( bytes[ i ] );
			}
            return `data:image/png;base64,${window.btoa(binary)}`
        }
    } catch (error) {
        return '';
    }
}

export const GetAccountInfo = async () => {
    try {
        const response = await HttpGraphMicrosoftRequest().get(`/v1.0/me`)
        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return null
    }
}

export interface IGetAccountInfo {
    businessPhones: string[]
    displayName: string
    givenName: string
    jobTitle: any
    mail: string
    mobilePhone: any
    officeLocation: string
    preferredLanguage: any
    surname: string
    userPrincipalName: string
    id: string
}
  